module.exports = __webpack_public_path__ + "img/dwarf_12.661fd45d.png";